import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function VideoGallery({ data }) {
    const [previousVideoPage, setPreviousVideoPage] = useState();

    const showOrHideVideoPage = (pageNumber, show) => {
        let pageToShow = document.getElementsByClassName("video_page_" + pageNumber);
        for (let i = 0; i < pageToShow.length; i++) {
            if (show) {
                pageToShow[i].style.display = "block";
            } else {
                pageToShow[i].style.display = "none";
            }
        }
    };

    const switchVideoPage = (pageNumber) => {
        if (previousVideoPage) {
            if (pageNumber === previousVideoPage) {
                return false;
            }
            showOrHideVideoPage(previousVideoPage, false);
            showOrHideVideoPage(pageNumber, true);
        } else {
            showOrHideVideoPage(pageNumber, true);
            window.jQuery("#videoPager_" + pageNumber).addClass("active_page");
        }
        if (window.jQuery("#videoPager_" + previousVideoPage).hasClass("active_page")) {
            window.jQuery("#videoPager_" + previousVideoPage).removeClass("active_page");
            window.jQuery("#videoPager_" + pageNumber).addClass("active_page");
        }
        setPreviousVideoPage(pageNumber);
    };

    const switchVideoPageAndSuppressEvent = (e, pageNumber) => {
        e.preventDefault();
        switchVideoPage(pageNumber);
    };

    useEffect(() => {
        // Ensure jQuery is loaded before using it
        if (window.jQuery) {
            window.jQuery(document).ready(function() {
                switchVideoPage(1);
            });
        }
    }, []);

    const pageListElements = [];
    for (let i = 1; i < Math.ceil( data.videos.length / 4 ) + 1; i++) {
        pageListElements.push(
            <li key={ i } className="page-item">
                <a href="" onClick={ (e) => switchVideoPageAndSuppressEvent(e, i) } className="page-link" id={ "videoPager_" + i }>{ i }</a>
            </li>
        );
    }

    return (
        <div key={data.documentId} className="video-gallery" style={{width:'100%'}}>
            <div className="views-row views-row-2 views-row-even" style={{width:'100%'}}>

                <article id="node-25" className="node node-video-gallery node-promoted node-teaser clearfix" about="/node/25" typeof="sioc:Item foaf:Document">

                    <div className="container-fluid video-container" style={{ maxWidth: "1270px" }} id="videoGallery">

                        <div className="row" style={{width:'100%'}}>

                            <h2 className="section-headline-small">
                                VIDEOS
                            </h2>
                            <hr style={{ borderTop: "2px solid #333" }} />
                            {/*previous color    #c9cacb*/}
                        </div>


                        <div className="row" style={{width:'100%'}}>

                            <div className="featured-video col-xs-12 col-sm-10 col-sm-offset-1">
                                <iframe className="img-responsive video-control-featured" src={ data.videos[0].youtubeVideoLink } allowFullScreen="">
                                </iframe>

                                <p className="body-text featured-video-title">
                                    { data.videos[0].title }
                                </p>

                                <p className="featured-video-info">
                                    {/* The "T00:00:00" is needed to prevent timezone conversion using the current time.  Otherwise it is possible at certain times of the day that the dates will be behind by 1 day. */}
                                    { new Date(data.videos[0].date + "T00:00:00").toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'}) } &nbsp; | &nbsp; { data.videos[0].location }
                                </p>

                            </div>

                        </div>

                        <div className="row video-container-grid" style={{width:'100%'}}>

                            {data.videos.filter((_, videoIdx) => videoIdx !== 0).map((video, videoIdx) => (
                                <div key={ videoIdx } className={ "col-sm-3 col-xs-12 video-item video_page_" + Math.ceil( (videoIdx+1) / 4 ) } style={{width:'100%'}} >
                                    <iframe className="img-responsive video-control" src={ video.youtubeVideoLink } allowFullScreen="" style={{maxWidth:'100%'}}>
                                    </iframe>

                                    <p className="body-text video-title">
                                        { video.title }
                                    </p>

                                    <p className="video-info">
                                        {/* The "T00:00:00" is needed to prevent timezone conversion using the current time.  Otherwise it is possible at certain times of the day that the dates will be behind by 1 day. */}
                                        { new Date(video.date + "T00:00:00").toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'}) } &nbsp; | &nbsp; { video.location }
                                    </p>
                                </div>
                            ))}

                        </div>

                        <div className="center-align" style={{display: 'flex', justifyContent: 'center'}}>
                            <nav aria-label="Page navigation">
                                <ul className="pagination">
                                    { pageListElements }
                                </ul>
                            </nav>
                        </div>

                    </div>

                </article>

            </div>
        </div>
    );
}

export default VideoGallery;
